import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=13a22094&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=13a22094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a22094",
  null
  
)

export default component.exports